<template>
  <div class="BarcodeOut mb-5">
    <div :style="{ margin: boxMargin }">
      <div class="s-full border">
        <table class="barcode__table align-center" cellpadding="5px">
          <tr height="40px">
            <td class="align-left" width="240px;"><AFitText>{{data.customer_name}}</AFitText></td>
            <td class="right contract_date" style="border-bottom:none;">{{data.contract_date}}</td>
          </tr>
          <tr height="100px">
            <td class="align-left product_name" colspan="2">{{data.product_name}}</td>
          </tr>          
        </table>
        <div class="barcode">
          <div class="of-hidden" style="width: 350px;">
            <VueBarcode 
              height="40" 
              margin="0" 
              :width="3.5"
              :value="data.contract_code" 
              :displayValue="false" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import AFitText from '@/shared/AFitText';

export default {
  name: "BarcodeOut",
  components: {VueBarcode, AFitText},
  props: {
    config: {
      type: Object,
      default: function() {
        return {
          margin_left: 0,
          margin_top: 0,
        }
      }
    },
    data: {
      type: Object,
      require: true
    },
  },
  computed: {
    boxMargin() {
      let margin_top = this.config.margin_top ? this.config.margin_top + "px" : 0;
      let margin_left = this.config.margin_left ? this.config.margin_left + "px" : 0;
      return "" + margin_top + " 0 0 " + margin_left;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";
.BarcodeOut {
  width: 370px;
  height: 200px;
  padding: 10px 10px;
  .barcode__table {
    width: 370px;
    font-size: 25px;
    border-collapse: collapse;
    .product_name {
      font-size: 35px;
    }
    .contract_date {
      font-size: 20px;
    }
  }
  .barcode {
    > div {
      padding: 10px 5px;
      > div {
        margin-right: 15px;
      }
    }
  }
}
</style>
<style type="text/css" media="print"> 
.BarcodeOut {
  size: 70mm 40mm;
  font-family: "돋움";
  page-break-after: always;
} 
</style>

